export default function auth({ next, store }) {
  const isLoggedIn = store.getters['user/isLoggedIn'];
  const user = store.getters['user/loggedInUser'];

  if (!isLoggedIn || !user) {
    return next({ name: 'Login' });
  }
  if (!user.userToken) {
    return next({ name: 'SessionExpired' });
  }
  return next();
}
